import React, { FC } from 'react';

import { useTheme } from '@mui/material';
import { styled } from '@mui/material';
import { alpha, keyframes } from '@mui/material/styles';

interface LoadingOverlayProps {
  startColor?: string;
  middleFirstColor?: string;
  middleSecondColor?: string;
  finishColor?: string;
  borderRadius?: string | number;
}

const LoadingOverlay: FC<LoadingOverlayProps> = ({
  startColor,
  middleFirstColor,
  middleSecondColor,
  finishColor,
  borderRadius = 0,
}) => {
  const theme = useTheme();
  startColor = startColor || alpha(theme.palette.common.violetSecondary, 0.3);
  middleFirstColor = middleFirstColor || theme.palette.common.blueDark;
  middleSecondColor = middleSecondColor || alpha(theme.palette.common.violetSecondary, 0.3);
  finishColor = finishColor || theme.palette.common.transparent;

  return (
    <Wrapper
      startColor={startColor}
      middleFirstColor={middleFirstColor}
      middleSecondColor={middleSecondColor}
      finishColor={finishColor}
      borderRadius={borderRadius}
    />
  );
};

export default LoadingOverlay;

const gradient = keyframes`
  0% {
    background-size: 1000% 200%;
    background-position: 0% 0%;
  }

  100% {
    background-size: 200% 200%;
    background-position: 100% 0%;
  }
`;
const Wrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'startColor' &&
    prop !== 'middleFirstColor' &&
    prop !== 'middleSecondColor' &&
    prop !== 'finishColor' &&
    prop !== 'borderRadius',
})<{
  startColor: string;
  middleFirstColor: string;
  middleSecondColor: string;
  finishColor: string;
  borderRadius: number | string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${({ startColor, middleFirstColor, middleSecondColor, finishColor }) =>
      `${startColor}, ${middleFirstColor},${
        middleSecondColor ? middleSecondColor + ', ' : ''
      } ${finishColor}`}
  );
  background-size: 200% 200%;
  animation: ${gradient} 3s ease-in-out infinite;
  animation-direction: alternate;
  opacity: 0.2;
  border-radius: ${({ borderRadius }) => borderRadius}px;
`;
